import { DevicesProvider } from '../../providers/devices/devices';
import { TasksProvider } from '../../providers/tasks/tasks';
import { TaskDetailPage } from '../task-detail/task-detail';
import { Component, ChangeDetectorRef } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ActionSheetController,
  AlertController
} from 'ionic-angular';
import { TaskQL, Task } from '../../providers/tasks/models';
import { ProvidersProvider } from '../../providers/providers/providers';
import { Provider } from '../../providers/providers/models';
import { UtilsProvider } from '../../providers/utils/utils';

@IonicPage()
@Component({
  selector: 'page-installer-tasks',
  templateUrl: 'installer-tasks.html'
})
export class InstallerTasksPage {
  public tasks;
  private selectedStatus: Array<string> = [
    Task.StatusEnum.Scheduled,
    Task.StatusEnum.Inprogress
  ];
  private selectedType: string = '';
  private types: Array<string> = ['Question', 'Incident', 'Problem', 'Task'];
  private isloading: boolean = false;

  private providers: Provider[];
  private updateTask: any;

  private currentTasks: TaskQL[];
  private futureTasks: TaskQL[];
  private unscheduledTasks: TaskQL[];

  private futureCollapsed: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private providersProvider: ProvidersProvider,
    public utilsProvider: UtilsProvider,
  ) {
    this.isloading = false;
    this.updateTask = this.navParams.get('updateTask');
    this.navParams.data.updateTask = null;
  }
  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.providersProvider.getProviders().subscribe(providersResult => {
      this.providers = providersResult;
      this.initTasks();
    });
  }

  initTasks(event?) {
    this.utilsProvider.checkVersion();
    // updateTask
    if (event) {
      this.currentTasks = [];
      this.futureTasks = [];
    }

    this.tasksProvider.getTasks({
      limit: 100,
      filters: {
        status: {
          _in: [Task.StatusEnum.Unscheduled, Task.StatusEnum.ToReschedule]
        }
      }
    },false).subscribe(data => {
      const tasks = data.items;
      this.unscheduledTasks = tasks.filter(itm => {
        const isAvailable = !this.utilsProvider.unscheduledHideCheck(itm)
        return isAvailable;
      });

      if (this.updateTask) {
        const redirTask = this.tasks.filter(tsk => {
          return tsk.id === this.updateTask.id;
        })[0];

        if (redirTask) {
          this.openTask(redirTask);
        }
      } 

      this.cd.detectChanges();
      this.isloading = true;
      if (event) event.complete();
    });

    this.tasksProvider.getTasks({
        limit: 100,
        filters: {
          status: {
            _in: [Task.StatusEnum.Scheduled, Task.StatusEnum.Inprogress]
          }
        }
      })
      .subscribe(data => {
        const todayEnd = new Date();
        todayEnd.setHours(23);
        todayEnd.setMinutes(59);
        todayEnd.setSeconds(59);
        const tasks = data.items;

        this.futureTasks = tasks.filter(itm => {
          return itm.assignedDate > todayEnd.getTime() && (itm.status == Task.StatusEnum.Scheduled || itm.status == Task.StatusEnum.Inprogress);
        });

        this.currentTasks = tasks.filter(itm => {
          return itm.assignedDate <= todayEnd.getTime() && (itm.status == Task.StatusEnum.Scheduled || itm.status == Task.StatusEnum.Inprogress);
        });

        if (this.updateTask) {
          const redirTask = this.tasks.filter(tsk => {
            return tsk.id === this.updateTask.id;
          })[0];

          if (redirTask) {
            this.openTask(redirTask);
          }
        }

        this.cd.detectChanges();
        this.isloading = true;
        if (event) event.complete();
      });
  }

  expandCollapse() {
    this.futureCollapsed = !this.futureCollapsed;
  }

  doRefresh(event) {
    this.initTasks(event);
  }

  getDeviceType(task: TaskQL) {
    return this.devicesProvider.getDeviceTypeLabel(task.deviceType);
  }

  getProviderName(id: string) {
    let provider = this.providers.filter(itm => itm.id === id)[0];
    let lbl = provider && provider.name ? provider.name : 'none';
    lbl = lbl === 'none' ? this.utilsProvider.groupSnnToName(id) : lbl;
    return lbl;
  }

  getProviderColor(id) {
    let provider = this.providers.filter(itm => itm.id === id)[0];
    let clr = provider && provider.color ? provider.color : '#666';
    return clr;
  }

  openTask(task) {
    const cacheTask = JSON.parse(JSON.stringify(task));
    this.tasksProvider.setSelectedTask(cacheTask);
    this.navCtrl.push(TaskDetailPage, { task: cacheTask });
  }

  shortAddress(address){
    return address.split(',').slice(0,2);
  }
}



// WEBPACK FOOTER //
// ./src/pages/installer-tasks/installer-tasks.ts